import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterNavigationChange = false;

    constructor(private router: Router) {
        // clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterNavigationChange) {
                    // only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // clear alert
                    this.subject.next(undefined);
                }
            }
        });
    }

    clearAlert(timer: any = 3000) {
        setTimeout(_ => {
            this.subject.next(undefined);
        }, timer);
    }

    success(message: string, keepAfterNavigationChange = false, timer: number = 3000) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
        this.clearAlert(timer);
    }

    error(message: string, keepAfterNavigationChange = false, timer: number = 3000) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
        this.clearAlert(timer);
    }
    alert(message: string, keepAfterNavigationChange = false, timer: number = 5000) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
        this.clearAlert(timer);
    }
    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}